import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useRootLayoutDirection = (isSideGNBLayoutMode: boolean): void => {
  const { pathname } = useLocation()
  useEffect(() => {
    const root: HTMLElement | null = document.getElementById('root')
    if (root) root.setAttribute('data-direction', isSideGNBLayoutMode ? 'row' : 'column')
  }, [isSideGNBLayoutMode, pathname])
}

export default useRootLayoutDirection
